import { RootState } from 'redux/store';

export const selectRouteMap = (state: RootState) => state.pathFinding.routeMap;

export const selectSettingParams = (state: RootState) => state.pathFinding.settingParams;

export const selectRunningState = (state: RootState) => state.pathFinding.runningState;
